import mapFunction from './mapResources';

export default mapFunction('order_material_documents', {
    isFetching: false,
    items: []
});